import { defineComponent } from 'vue'
import type { IFullscreenLoaderProps } from './types'
import { Spinner } from '../spinner'
import type { ISpinnerProps } from '../spinner/types'
import { useFullscreenLoader } from './hooks/useFullscreenLoader'

const FullscreenLoader = defineComponent<IFullscreenLoaderProps>({
  setup(props) {
    const spinnerProps: ISpinnerProps = props.spinner || { size: 14 };
    const data = useFullscreenLoader();

    return () => {
      return (
        <div
          style={[{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 105,
            overflow: 'hidden',
            flexDirection: 'column',
            flexWrap: 'wrap'
          }, data.style.value]}
          class={['space-y-4', data.class.value || 'bg-findex-900']}
        >
          <Spinner {...spinnerProps} />
          { props.text && <div class='text-gray-500 text-sm'>{props.text}</div> }
        </div>
      )
    }
  }
})

FullscreenLoader.props = ['spinner', 'text']

export default FullscreenLoader
